module.exports = __webpack_public_path__ + "img/1.e15fdc5c.png";